import {API_URL, authHeaders, jsonHeaders} from "./index";

export async function apiGetLandingMoods() {
    const res = await fetch(`${API_URL}/landing/moods`);
    return res.json();
}

// limit : 3 (défaut) à 6 fils (le bloc « Fils de discussion » propose 3 ou 6).
export async function apiGetLandingThreads(limit) {
    const res = await fetch(`${API_URL}/landing/threads${limit ? `?limit=${encodeURIComponent(limit)}` : ""}`);
    return res.json();
}

export async function apiGetLandingStats() {
    const res = await fetch(`${API_URL}/landing/stats`);
    return res.json();
}

// Page publiée (déjà résolue par le serveur). null = pas de réponse exploitable : la landing par défaut prend le relais.
export async function apiGetLandingPage() {
    try {
        const res = await fetch(`${API_URL}/landing/page`);
        if (!res.ok) return null;
        return await res.json();
    } catch {
        return null;
    }
}

// --- Administration (rôle admin) ---

const NETWORK_ERROR = "Impossible de contacter le serveur. Vérifiez votre connexion et réessayez.";

async function safeJson(promise) {
    try {
        const res = await promise;
        return res.status === 204 ? {ok: true} : await res.json();
    } catch {
        return {error: NETWORK_ERROR};
    }
}

export const apiAdminGetLanding = () => safeJson(fetch(`${API_URL}/admin/landing`, {headers: authHeaders()}));

// draftRevision : révision du brouillon lue par l'éditeur (null = aucun brouillon vu) ; le serveur répond 409
// DRAFT_CONFLICT si un autre administrateur l'a modifié depuis.
export const apiAdminSaveLandingDraft = (page, basedOnVersionId, draftRevision) =>
    safeJson(fetch(`${API_URL}/admin/landing/draft`, {
        method: "PUT", headers: jsonHeaders(),
        body: JSON.stringify({page, based_on_version_id: basedOnVersionId, draft_revision: draftRevision}),
    }));

export const apiAdminDiscardLandingDraft = () =>
    safeJson(fetch(`${API_URL}/admin/landing/draft`, {method: "DELETE", headers: authHeaders()}));

export const apiAdminLandingPreview = () => safeJson(fetch(`${API_URL}/admin/landing/preview`, {headers: authHeaders()}));

export const apiAdminPublishLanding = ({note, force} = {}) =>
    safeJson(fetch(`${API_URL}/admin/landing/publish`, {method: "POST", headers: jsonHeaders(), body: JSON.stringify({note, force})}));

export const apiAdminListLandingVersions = () => safeJson(fetch(`${API_URL}/admin/landing/versions`, {headers: authHeaders()}));

export const apiAdminRestoreLandingVersion = (id) =>
    safeJson(fetch(`${API_URL}/admin/landing/versions/${id}/restore`, {method: "POST", headers: authHeaders()}));

// --- Aide IA (propositions seulement : rien n'est enregistré côté serveur) ---

export const apiAdminLandingAiDraft = ({scope, type, brief, current}) =>
    safeJson(fetch(`${API_URL}/admin/landing/ai/draft`, {
        method: "POST", headers: jsonHeaders(), body: JSON.stringify({scope, type, brief, current}),
    }));

export const apiAdminLandingAiSectionDraft = ({brief}) =>
    safeJson(fetch(`${API_URL}/admin/landing/ai/section-draft`, {
        method: "POST", headers: jsonHeaders(), body: JSON.stringify({brief}),
    }));

export const apiAdminLandingAiReview = (page) =>
    safeJson(fetch(`${API_URL}/admin/landing/ai/review`, {
        method: "POST", headers: jsonHeaders(), body: JSON.stringify({page}),
    }));

// --- Humeur des visiteurs et tirage de pseudo (routes publiques) ---

export async function apiGetVisitorMoods() {
    try {
        const res = await fetch(`${API_URL}/landing/visitor-moods`);
        if (!res.ok) return null;
        return await res.json();
    } catch {
        return null;
    }
}

// true si le vote est enregistré ; jamais d'exception.
export async function apiPostVisitorMood(level) {
    try {
        const res = await fetch(`${API_URL}/landing/visitor-mood`, {
            method: "POST", headers: {"Content-Type": "application/json"}, body: JSON.stringify({level}),
        });
        return res.ok;
    } catch {
        return false;
    }
}

// Tableau de pseudos libres ({pseudo, emoji, couleur}) ou null si le tirage est indisponible.
export async function apiGetPseudoDraw() {
    try {
        const res = await fetch(`${API_URL}/landing/pseudo-draw`);
        if (!res.ok) return null;
        const body = await res.json();
        return Array.isArray(body.pseudos) ? body.pseudos : null;
    } catch {
        return null;
    }
}

// Téléversement d'une image de rubrique libre (multipart, champ « image ») : {url} ou {error, message}.
export function apiAdminUploadLandingImage(file) {
    const formData = new FormData();
    formData.append("image", file);
    return safeJson(fetch(`${API_URL}/admin/landing/images`, {method: "POST", headers: authHeaders(), body: formData}));
}
